import { render, staticRenderFns } from "./TaskMainJob.vue?vue&type=template&id=9fb68724"
import script from "./TaskMainJob.vue?vue&type=script&lang=js"
export * from "./TaskMainJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports